import * as entity from '@common/domain/entities/StockItemSupplier'
import * as app from '@framework/app';
import { FormBuilderControlListHelper } from '../../formbuilder/FormBuilderControlListHelper';
import { IDataEndPoint } from '../../../framework/interfaces/IEntity';
import { IApiServiceCommand } from '../../../services/api/api.service';
import { ViewType } from '../../../framework/core/Enums';
import { Permissions } from '../../../config/AppEnums';
export class StockItemSupplierEndPoints extends entity.StockItemSupplierEndPoints {
  search?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/stockItemSupplier/lazyPerStock/" + serviceCommand.context.entityId }, method: "POST" };
  pagingTotalCount?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/stockItemSupplier/lazyPerStockCount/" + serviceCommand.context.entityId }, method: "POST" };
}

export class StockItemSupplierFormFields extends entity.StockItemSupplierFormFields {
  constructor() {
    super();
    try {
      if (this["id"]) this.splice(this.indexOf(this["id"]), 1)
      if (this["changedById"]) this.splice(this.indexOf(this["changedById"]), 1)
      if (this["datestamp"]) this.splice(this.indexOf(this["datestamp"]), 1)
      if (this["status"]) this.splice(this.indexOf(this["status"]), 1)
      if (this["stockItemId"]) this.splice(this.indexOf(this["stockItemId"]), 1)
      if (this["code"]) this.splice(this.indexOf(this["code"]), 1)
      //if (this["supplierId"]) this.splice(this.indexOf(this["supplierId"]), 1)
      this.supplierId.name = "Supplier";  
      this.supplierId.viewType = ViewType.AutoComplete;
      this.supplierId.dataEndPoint = { url: app.config.controllerRouteRoot + "/Supplier/detail/" };
      this.supplierId.searchEndPoint = { url: app.config.controllerRouteRoot + "/Supplier/searchAuto/" };
      this.supplierId.dataDisplayField = "name";
      this.supplierId.dataIdField = "id";
      this.price.viewType = ViewType.InputGroupString;
      this.price.settings = { prefix: 'R' };
      this.price.show = function (entity, auth) {
        if (!auth)
          return false;
        return auth.hasAnyPermissions(Permissions.StockItemsModuleEdit, Permissions.CatalogViewPrices)
      }
      this.price.required = true;

      this.supplierId.required = true;
    } catch  { }
  }
}

export class StockItemSupplierForm extends entity.StockItemSupplierForm {
  protected stockItemSupplierFormEndPoints: StockItemSupplierEndPoints = new StockItemSupplierEndPoints();
  protected stockItemSupplierFormFields: StockItemSupplierFormFields = new StockItemSupplierFormFields();

  public onLoaded: Function = function (context: any, entity?: any) {
    if (!context.authService.hasAnyPermissions(Permissions.StockItemsModuleEdit)) {
      context.parent.componentInstance[0].component.makeFormReadOnly(true)
    } if (context.entityId == "00000000-0000-0000-0000-000000000000") {
      context.entityData.stockItemId = context.parent.previousEntityId;
    }
  }
}

export class StockItemSupplierListColumns extends entity.StockItemSupplierListColumns {
  constructor() {
    super();
    try {
      if (this["id"]) this["id"].visible = false;
      if (this["changedById"]) this.splice(this.indexOf(this["changedById"]), 1)
      if (this["datestamp"]) this.splice(this.indexOf(this["datestamp"]), 1)
      this.splice(0, this.length);
      this.price.visible = function (entity, auth) {
        if (!auth)
          return false;
        return auth.hasAnyPermissions(Permissions.StockItemsModuleEdit, Permissions.CatalogViewPrices)
      }
      var priceFormatted = FormBuilderControlListHelper.getListColumn("price", "Price", null, null, "price_formatted")
      priceFormatted.visible = function (entity, auth) {
        if (!auth)
          return false;
        return auth.hasAnyPermissions(Permissions.StockItemsModuleEdit, Permissions.CatalogViewPrices)
      }
      this.push(this.id);
      this.push(FormBuilderControlListHelper.getListColumn("supplier.name", "Supplier", null, null, "supplier_name"));
      //this.push(this.code);
      this.push(priceFormatted);
    } catch  { }
  }
}

export class StockItemSupplierList extends entity.StockItemSupplierList {
  protected stockItemSupplierListEndPoints: StockItemSupplierEndPoints = new StockItemSupplierEndPoints();
  protected stockItemSupplierListColumns: StockItemSupplierListColumns = new StockItemSupplierListColumns();
}

export class BladeSetup {
  public onSaveEvent = function (prop) {
    if (prop.listIndex == 0) {
      prop.parent.parent.getBladeByIndex(1).reloadFormByIndex(1);
    }
  }
  public onFormLoad: Function = function (data: any, formIndex?: any, context?: any) {

  }
}
